import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import type { PrimaryHeatingOptionDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

export const getPrimaryHeatingOptionsSelector = selector<PrimaryHeatingOptionDTO[]>({
    key: 'getPrimaryHeatingOptionsSelector',
    get: async ({ get }) => {
        const { productName } = get(opcInfoAtom);
        return await OnlineSales.getPrhPrimaryHeatingOptions(productName);
    }
});
